import { api } from '../DefaultService';
import { IPaginationParams } from '../types';
import {
  IWhatsAppNumbersCreateProps,
  IWhatsAppNumbersFilterProps,
  IWhatsAppNumbersProps,
  IWhatsAppNumbersSimpleProps,
  IWhatsAppNumbersUpdateParams,
} from './types';

const ENDPOINT = 'v1/whatsApp/numbers';

export const createWhatsAppNumberAsync = async (
  data: IWhatsAppNumbersCreateProps,
): Promise<IWhatsAppNumbersProps> => {
  return await api
    .post(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateWhatsAppNumberAsync = async ({
  id,
  data,
}: IWhatsAppNumbersUpdateParams): Promise<IWhatsAppNumbersProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteWhatsAppNumberAsync = async (id: number) => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};

export const getWhatsAppNumberByIdAsync = async (
  id: number,
): Promise<IWhatsAppNumbersProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllWhatsAppNumbersByLicenseAsync = async (
  pagination?: IPaginationParams,
  filter?: IWhatsAppNumbersFilterProps,
): Promise<IWhatsAppNumbersSimpleProps[]> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`, {
      params: { ...pagination, ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllWhatsAppNumbersByLicenseCountAsync = async (
  filter: IWhatsAppNumbersFilterProps,
): Promise<number> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense/count`, {
      params: { ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
